import React from 'react';

import './styles.css';

interface Props {
};

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} [example]
 *
 * @augments {Component<Props>}
 */
const Column: React.FC<Props> = (props) => {

    return (
        <div className='Column'>
            {props.children}
        </div>
    );

};

export default Column;
